/* ej-card-discount.js — struck original + discounted price on PRODUCT CARDS
   (homepage featured collections, collection pages, search). Never on product
   pages: the buy column there has its own eligibility-aware rendering in
   pdp-buyflow.liquid / pdp-coupon-ui.liquid, and this file exits at once on
   /products/* so the two can never disagree.

   Why this exists (2026-09-14): erojoy-main-popup.js used to strike EVERY
   dollar figure on every page once a code was in the cookie, including
   products the code did not cover. That rewrite was disabled on 2026-09-10
   ("only show discount applied on the products the specific discount applies
   to"), which also removed the homepage strikes Rudi wanted kept. This file
   restores them, but only for cards whose product handle is in
   window.EJ_DISCOUNTS[code].products (assets/constants.js, the same map the
   PDP uses), at that map's percentage.

   Where the code comes from, in order: ?coupon= / ?discount= in the URL, the
   discount_code cookie Shopify sets on the /discount/CODE hop, then the
   erojoy_discount localStorage entry the popup script keeps for 3 days.
   Unknown code or no map loaded: nothing changes — a true discount omitted is
   safer than a false one shown. Runs on DOMContentLoaded and again on DOM
   mutation (featured collections and quick-add render late). Idempotent:
   each rewritten price element is marked data-ej-card-disc. */
(function () {
  'use strict';
  if (/^\/(products\/|checkout|cart)/.test(location.pathname)) return;

  function param(k) { try { return new URLSearchParams(location.search).get(k) || ''; } catch (e) { return ''; } }
  function cookie(n) { var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + n + '=([^;]+)')); return m ? decodeURIComponent(m[1]) : ''; }
  function stored() { try { var s = JSON.parse(localStorage.getItem('erojoy_discount') || 'null'); if (s && s.code && (!s.exp || Date.now() < s.exp)) return String(s.code); } catch (e) {} return ''; }
  function currentCode() { var c = param('coupon') || param('discount') || cookie('discount_code') || stored(); return /^[A-Za-z0-9_-]{2,30}$/.test(c) ? c.toUpperCase() : ''; }

  var css = '.ej-card-old{text-decoration:line-through;opacity:.55;margin-right:6px}' +
            '.ej-card-new{color:#0a8f4c;font-weight:700}' +
            '.price .ej-card-old,.price .ej-card-new{font-size:inherit}';
  var styled = false;
  function ensureStyle() { if (styled) return; styled = true; var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st); }

  var MONEY = /^\s*\$\s?(\d{1,4}(?:,\d{3})*(?:\.\d{2})?)\s*$/;

  function handleOf(card) {
    var a = card.querySelector('a[href*="/products/"]'); if (!a) return '';
    var m = a.getAttribute('href').match(/\/products\/([a-z0-9-]+)/i); return m ? m[1].toLowerCase() : '';
  }

  function rewriteCard(card, pct) {
    /* The figure the customer actually sees: the sale price when the card is on
       sale, else the regular price. Only the FIRST such element per card. */
    var el = card.querySelector('.price .price-item--sale.price-item--last') ||
             card.querySelector('.price .price-item--sale') ||
             card.querySelector('.price .price-item--regular');
    if (!el || el.hasAttribute('data-ej-card-disc')) return;
    var m = el.textContent.match(MONEY); if (!m) return;                 // not a plain USD figure: leave it
    var orig = parseFloat(m[1].replace(/,/g, '')); if (!(orig > 0)) return;
    var disc = orig * (1 - pct / 100);
    ensureStyle();
    el.setAttribute('data-ej-card-disc', '1');
    el.textContent = '';
    var s = document.createElement('s'); s.className = 'ej-card-old'; s.textContent = '$' + orig.toFixed(2);
    var n = document.createElement('span'); n.className = 'ej-card-new'; n.textContent = '$' + disc.toFixed(2);
    el.appendChild(s); el.appendChild(n);
  }

  function run() {
    var code = currentCode(); if (!code) return;
    var map = window.EJ_DISCOUNTS && window.EJ_DISCOUNTS[code]; if (!map || !(map.pct > 0)) return;
    var list = map.products;                                               // no list = code covers every product
    var cards = document.querySelectorAll('.card-wrapper, .product-card-wrapper');
    for (var i = 0; i < cards.length; i++) {
      var h = handleOf(cards[i]); if (!h) continue;
      if (list && list.indexOf(h) === -1) continue;
      rewriteCard(cards[i], map.pct);
    }
  }

  function start() {
    run();
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; run(); }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }
  /* constants.js (the EJ_DISCOUNTS map) is a deferred script that precedes this
     one in theme.liquid, so it is defined by DOMContentLoaded. */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
